import React from 'react';
import { useTrainingTranslation } from '../hooks/useTrainingTranslation';

const TrainingHeader = () => {
  const { getTranslation } = useTrainingTranslation();
  const translation = getTranslation();

  return (
    <div className="text-center">
      <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-blue-50 border border-blue-100 mb-6">
        <span className="w-2 h-2 rounded-full bg-blue-500 animate-pulse" />
        <span className="text-sm font-semibold text-blue-700 tracking-wide">
          {translation.tracks.label}
        </span>
      </div>
      <h2 className="text-4xl font-bold text-gray-900">{translation.title}</h2>
      <p className="mt-4 text-xl text-gray-600 max-w-3xl mx-auto">{translation.subtitle}</p>
    </div>
  );
};

export default TrainingHeader;
